'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { KAKAO_MOMENT_PIXEL_ID, trackKakaoPixelEvent } from '@/utils/analytics/kakao-pixel';
import { trackTossPixelEvent } from '@/utils/analytics/toss-pixel';
const PageViewEventLoggerContent = () => {
  const $ = _c(6);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t0 = [pathname, searchParams];
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[3] !== pathname || $[4] !== searchParams) {
    t1 = [pathname, searchParams];
    $[3] = pathname;
    $[4] = searchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(_temp2, t1);
  return null;
};
export const PageViewEventLogger = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorBoundary fallback={null}><Suspense><PageViewEventLoggerContent /></Suspense></ErrorBoundary>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp() {
  trackKakaoPixelEvent(KAKAO_MOMENT_PIXEL_ID, "pageView");
}
function _temp2() {
  trackTossPixelEvent("pageView");
}